import {useContext, useEffect, useState} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "./GlobalReducer";
import {mergeBasket} from "./api/customer";

export default function BasketServerSync(){

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [isInitRender, setIsInitRender] = useState(false);

    const updateBasket = () => {
        if (state.customer?.id && state.customer?.sign) {
            mergeBasket(state.customer.id, state.customer.sign, state.basket).then(basket => {
                const currentBasketUid = state.basket.map(item => item.itemId + item.quantity).sort().join('|')
                const newBasketUid = basket.map(item => item.itemId + item.quantity).sort().join('|')

                if (currentBasketUid !== newBasketUid) {
                    dispatch({type: ReducerActionType.SET_BASKET, payload: basket})
                }
            })
        }

    }

    useEffect(() => {
        window.addEventListener("focus", updateBasket);
    }, []);

    useEffect(() => {
        if (state.customer?.id && state.customer?.sign) {
            updateBasket()
        }
    }, [state.customer?.id]);

    useEffect(() => {
        if(!isInitRender){
            setIsInitRender(true)
            return
        }
        if(!state.customer?.id || !state.customer?.sign){
            return
        }

        mergeBasket(state.customer.id, state.customer.sign, state.basket, true).then(basket => {
            console.log('Basket', basket)
        })

    }, [state.basket]);


    return (<></>)
}